// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"a7752e6c","453":"2e7f7825","455":"40d2f6ec","469":"de6782c8","479":"535e64b6","680":"64c56791"}[chunkId] + ".chunk.js";
};